// DO NOT EDIT THIS FILE!!!
// Update it by running `rake javascript:update`

export const PUBLIC_JS_VERSIONS = {
  "ace/ace.js": "ace.js/1.4.13/ace.js",
  "ace/theme-chrome.js": "ace.js/1.4.13/theme-chrome.js",
  "ace/theme-chaos.js": "ace.js/1.4.13/theme-chaos.js",
  "jsoneditor.js": "@json-editor/json-editor/2.10.0/jsoneditor.js",
  "chart.min.js": "chart.js/3.5.1/chart.min.js",
  "chartjs-plugin-datalabels.min.js": "chartjs-plugin-datalabels/2.2.0/chartjs-plugin-datalabels.min.js",
  "diffhtml.min.js": "diffhtml/1.0.0-beta.30/diffhtml.min.js",
  "jquery.magnific-popup.min.js": "magnific-popup/1.1.0/jquery.magnific-popup.min.js",
  "pikaday.js": "pikaday/1.8.2/pikaday.js"
};